import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MULTISELECT_FILTER } from '@as-react/common-types';
import { capitalize } from '@as-react/common-utils';
import { CheckIcon } from '@yonderland/andes-icons';
import { Grid, Icon, Stack, Swatch, TextAlpha } from '@yonderland/andes-react';
const WHITE_FILTER_KEY = 'id_ffffff';
export const FilterItemContentColorFilter = ({ filter, onFilterItemChange, desktop, isCollapsedByDefault, }) => {
    const toggleFilterValue = (e) => {
        const filteredItem = filter.values.find((value) => value.filterKey === e.target.value);
        if (filteredItem) {
            onFilterItemChange({
                filterOn: filter.filterOn,
                filterOnName: filter.name,
                filteredItems: [
                    {
                        filterKeyName: filteredItem.name,
                        filterKey: filteredItem.filterKey,
                        filterOn: filter.filterOn,
                        filterOnName: filter.name,
                        filterType: MULTISELECT_FILTER,
                    },
                ],
                filterType: MULTISELECT_FILTER,
                filterDisplayHint: filter.displayHint,
                filterContentType: filter.filterContentType,
            });
        }
    };
    return (_jsx(Grid, { columns: 12, gap: "2", children: filter.values.map(value => (_jsx(Grid.Cell, { span: 6, children: _jsx(Stack, { gap: "1", align: "center", wrap: "nowrap", children: _jsx(Swatch, { id: desktop ? `color_${filter.name}_${value.filterKey}-desktop` : `color_${filter.name}_${value.filterKey}`, imageUrl: `/content/dam/general/lister/color_filters/${value.filterKey}.svg`, size: "sm", testId: `color_swatch_${filter.name}_${value.filterKey}`, name: `color_${filter.name}_${value.filterKey}`, value: value.filterKey, lazyLoad: isCollapsedByDefault === false, label: _jsxs(Stack, { gap: "2", align: "center", wrap: "nowrap", children: [_jsx(TextAlpha, { color: "neutral", children: capitalize(value.name) }), _jsx(TextAlpha, { as: "span", color: "subtle", children: `(${value.itemCount})` })] }), overlay: value.active ? (_jsx(Icon, { source: CheckIcon, color: value.filterKey === WHITE_FILTER_KEY ? 'neutral' : 'inverse', size: "xs" })) : null, hasBorder: true, onClick: toggleFilterValue }) }) }, `color_${filter.name}_${value.filterKey}`))) }));
};
